export const surveyText = {
  title: 'Take a Quick Survey',
  subtitle: 'Be eligible to earn a 35 dollar gift card!',
  uiExperienceTitle: 'Consumers - UI Experience',
  uiExperienceSubtitle:
    'These set of questions focus on user interface experience across both web and mobile web platforms.',
  financeAutoTitle: 'Consumers - Finance (Auto Financing)',
  financeAutoSubtitle:
    'These set of questions will focus on your auto financing experience and their needs.',
  financeMortgageTitle: 'Consumers - Finance (Mortgage Financing)',
  financeMortgageSubtitle:
    'These set of questions will focus on your mortgage financing experience and their needs.',
  insuranceAutoTitle: 'Consumers - Insurance (Auto Insurance)',
  insuranceAutoSubtitle:
    'These set of questions will focus on your auto insurance experience and their needs.',
  insuranceHomeTitle: 'Consumers - Insurance (Home Insurance)',
  insuranceHomeSubtitle:
    'These set of questions will focus on your home insurance experience and their needs.',
  submit: 'Submit Survey',
};
export const thankYouText = {
  header: 'Thank You for Your Feedback!',
  subheader:
    'We truly appreciate you taking the time to share your thoughts with us. Your input is invaluable in helping us improve and create a better experience for you!',
  othersurveys: 'Other surveys you might be interested in: ',
  financeAuto: 'Consumers For Finance - Auto',
  uiExperience: 'User Interface Experience',
  financeMortgage: 'Consumers For Finance - Mortgage',
  insuranceAuto: 'Consumers For Insurance - Auto',
  insuranceHome: 'Consumers For Insurance -Home',
};
export const surveyBtnAnswers = [
  {
    difficult: ['Very Easy', 'Easy', 'Neutral', 'Difficult', 'Very Difficult'],
    appealing: ['Very Appealing', 'Appealing', 'Neutral', , 'Unappealing', 'Very Unappealing'],
    slowFast: ['Very Fast', 'Fast', 'Average', 'Slow', 'Very Slow'],
    yesNo: ['Yes', 'No', 'Somewhat'],
    satistied: ['Very Satisfied', 'Satisfied', 'Neutral', 'Dissatisfied', 'Very Dissatisfied'],
    likeyUnlikely: ['Very Likely', 'Likely', 'Neutral', 'Unlikely', 'Very Unlikely'],
    helpful: ['Very Helpful', 'Helpful', 'Neutral', 'Somewhat Helpful', 'Not Helpful'],
    poorGood: ['Excellent', 'Good', 'Neutral', 'Poor', 'Very Poor'],
    important: ['Very Important', 'Important', 'Neutral', 'Slightly Important', 'Not Important'],
    lenderOption: ['National lender', 'Local lender', 'No preference'],
    fixedFlexible: ['Flexible', 'Fixed', 'No preference'],
    comfortable: [
      'Very Comfortable',
      'Comfortable',
      'Neutral',
      'Slightly Comfortable',
      'Not Comfortable',
    ],

    financeMostImportant: [
      'Interest rates',
      'Brand reputation',
      'Customer service',
      'Loan terms',
      'On-time payments',
      'Ability to refinance',
      'Quick approval process',
    ],
    insuranceMostImportant: [
      'Premium cost',
      'Coverage limits',
      'Deductible amount',
      'Policy exclusions and terms',
      'Insurer reputation/financial strength',
      'Claims handling & customer service',
      'Available discounts and bundling options',
    ],
    uiImprovements: [
      'Better User Interface',
      'Product Options',
      'Faster Approvals',
      'Transparent Pricing',
    ],
    paymentOption: ['Lower Payment', 'Higher Payment', 'No Preference'],
    moreFeatures: [
      'Personalized Recommendations',
      'Faster Quote Retrieval',
      'More lender Options',
      'Better Mobile Experience',
      'Flexible Payment',
    ],
  },
];

export const shortSurvey = [
  {
    questionsDifficult: [
      'How easy was it to find and compare financial products (loans, insurance, etc.) on our platform?',
    ],
    questionYesNo: [
      'Did you encounter any issues while using the platform (e.g., unclear information, slow load times, application difficulties)?',
    ],
    questionHelpful: [
      'How well did our platform help you compare different financial options (loans, insurance)?',
    ],
    questionsLikely: [
      {
        questionId: 'shortSurveyQ4',
        text: 'How likely are you to switch to a new insurance provider if offered lower premiums for the same coverage?',
      },
      {
        questionId: 'shortSurveyQ5',
        text: 'How likely are you to complete an application for a financial product directly through our platform?',
      },
    ],
    questionUiImprovements: ['What improvements would most enhance your experience?'],
    questionsImportant: [
      {
        questionId: 'shortSurveyQ7',
        text: 'How important is the ability to customize your loan or insurance policy to fit your needs?',
      },
      {
        questionId: 'shortSurveyQ8',
        text: 'How important is having live customer support available while you make financial decisions?',
      },
    ],
    questionPaymentOption: [
      'Would you prefer a financial product with a lower monthly payment but a longer repayment period, or a higher monthly payment with a shorter term?',
    ],
    questionFeatures: [
      'What additional features would encourage you to use our platform more frequently?',
    ],
    questionConfortable: [
      'How comfortable are you managing financial services (loans, insurance, payments) entirely online?',
    ],
  },
];
export const uiExperience = [
  {
    questionsDifficult: [
      {
        questionId: 'uiExperienceQ1',
        text: 'How easy was it to navigate the platform on a desktop?',
      },
      {
        questionId: 'uiExperienceQ2',
        text: 'How easy was it to navigate the platform on mobile?',
      },
    ],
    questionsAppealing: [
      {
        questionId: 'uiExperienceQ3',
        text: "Did you find the platform's layout and design visually appealing?",
      },
      {
        questionId: 'uiExperienceQ4',
        text: 'How would you rate the responsiveness of the web platform (load speed, transitions)?',
      },
      {
        questionId: 'uiExperienceQ5',
        text: 'How would you rate the responsiveness of the mobile web platform (load speed, transitions)?',
      },
    ],
    questionYesNo: [
      {
        questionId: 'uiExperienceQ6',
        text: 'Was it easy to complete your tasks (applying for loans, checking rates, etc.) on both web and mobile web?',
      },
      {
        questionId: 'uiExperienceQ7',
        text: 'Did you face any issues or bugs while navigating the platform on the web or mobile?',
      },
      {
        questionId: 'uiExperienceQ8',
        text: 'Were you able to easily read text and view images on the mobile web version of the platform?',
      },
    ],
    questionsSatisfied: [
      'How satisfied are you with the visual design on desktop versus mobile web?',
    ],
    feedback: [
      'What would you improve about the user interface on either platform (web or mobile web)',
    ],
  },
];

export const financeAuto = [
  {
    questionsEasy: [
      'How easy was it to find auto loan options on the platform (both web and mobile web)?',
    ],
    questionsYesNo: [
      {
        questionId: 'financeAutoQ2',
        text: 'Did the platform provide clear and understandable auto loan terms (interest rates, repayment periods)?',
      },
      {
        questionId: 'financeAutoQ3',
        text: 'Were you able to view and compare different auto loan options (e.g., 15-year, 30-year, ARM)easily?',
      },
      {
        questionId: 'financeAutoQ4',
        text: 'Did you feel confident in understanding the interest rates and loan amounts for auto loans?',
      },
      {
        questionId: 'financeAutoQ5',
        text: "Were there any auto loan options that you couldn't find on the platform that you were looking for?",
      },
      {
        questionId: 'financeAutoQ6',
        text: 'Did the platform provide adequate tools or calculators to help you evaluate auto loan affordability?',
      },
    ],
    questionsLikely: ['How likely are you to apply for an auto loan through the platform?'],
    questionsSatisfied: [
      'How satisfied are you with the speed of the application process for auto loans?',
    ],
    questionsGoodPoor: [
      'How would you rate the customer support experience regarding auto loan queries?',
    ],
    questionsImportant: [
      {
        questionId: 'financeAutoQ10',
        text: "How much do you consider the lender's reputation when applying for an auto loan?",
      },
      {
        questionId: 'financeAutoQ11',
        text: 'How important is the ability to make early payments or pay off your auto loan early without penalties?',
      },
      {
        questionId: 'financeAutoQ12',
        text: 'In terms of auto loan approval, how important is quick approval to you?',
      },
    ],
    questionsLenderInfluence: [
      {
        questionId: 'financeAutoQ13',
        text: 'What factors influence your decision to choose one auto lender over another?',
      },
      {
        questionId: 'financeAutoQ14',
        text: 'When choosing an auto loan lender, which of the following is most important to you?',
      },
    ],
    questionsFlexible: [
      'Do you prefer lenders who offer flexible payment plans or those with fixed terms?',
    ],

    feedback: [
      'What improvements would you suggest for the auto loan application process on both web and mobile web platforms?',
    ],
  },
];

export const financeMortgage = [
  {
    questionsEasy: [
      'How easy was it to find mortgage options on the platform (both web and mobile web)?',
    ],
    questionsYesNo: [
      {
        questionId: 'financeMortgageQ2',
        text: 'Did the platform provide clear and understandable mortgage terms (interest rates, repayment periods, fixed vs. adjustable)?',
      },
      {
        questionId: 'financeMortgageQ3',
        text: 'Were you able to view and compare different mortgage products (e.g., 15-year, 30-year, ARM) easily?',
      },
      {
        questionId: 'financeMortgageQ4',
        text: 'Did you feel confident in understanding your estimated monthly payments?',
      },
      {
        questionId: 'financeMortgageQ5',
        text: 'Were there any mortgage options (e.g., low down-payment, VA loans) you couldn’t find on the platform?',
      },
      {
        questionId: 'financeMortgageQ6',
        text: 'Did the platform provide adequate calculators or tools to help you estimate mortgage affordability?',
      },
    ],
    questionsLikely: ['How likely are you to apply for a mortgage through the platform?'],
    questionsSatisfied: [
      'How satisfied are you with the speed of the mortgage application process?',
    ],
    questionsGoodPoor: [
      'How would you rate the customer support experience regarding mortgage inquiries?',
    ],
    questionsImportant: [
      {
        questionId: 'financeMortgageQ10',
        text: "How much do you consider the lender's reputation when choosing a mortgage?",
      },
      {
        questionId: 'financeMortgageQ11',
        text: 'How important is the ability to make extra principal payments or refinance without penalties?',
      },
      {
        questionId: 'financeMortgageQ12',
        text: 'How important is a low down payment option to you?',
      },
    ],
    questionsLenderInfluence: [
      {
        questionId: 'financeMortgageQ13',
        text: 'What factors influence your decision to choose one mortgage lender over another?',
      },
      {
        questionId: 'financeMortgageQ14',
        text: 'When choosing a mortgage, which of the following is most important to you?',
      },
    ],
    questionsFlexible: [
      'Do you prefer lenders who offer adjustable-rate mortgages (ARMs) or fixed-rate mortgages?',
    ],
    feedback: [
      'What improvements would you suggest for the mortgage application process on both web and mobile web platforms?',
    ],
  },
];

export const insuranceAuto = [
  {
    questionsEasy: [
      'How easy was it to find auto insurance options on the platform (both web and mobile web)?',
    ],
    questionsYesNo: [
      {
        questionId: 'insuranceAutoQ2',
        text: 'Did the platform clearly explain coverage details like deductibles, limits, and premium amounts?',
      },
      {
        questionId: 'insuranceAutoQ3',
        text: 'Were you able to view and compare different auto insurance options (liability, collision, comprehensive) easily?',
      },
      {
        questionId: 'insuranceAutoQ4',
        text: 'Did you feel confident in understanding your estimated premium payments?',
      },
      {
        questionId: 'insuranceAutoQ5',
        text: 'Were there any auto insurance features (e.g., multi-car discount, pay-as-you-drive pricing) you expected but couldn’t find?',
      },
      {
        questionId: 'insuranceAutoQ6',
        text: 'Did the platform provide calculators or tools to help you estimate your insurance costs?',
      },
    ],
    questionsLikely: ['How likely are you to purchase auto insurance through the platform?'],
    questionsSatisfied: [
      'How satisfied are you with the speed of getting an auto insurance quote?',
    ],
    questionsGoodPoor: ['How would you rate our customer support for auto insurance inquiries?'],
    questionsImportant: [
      {
        questionId: 'insuranceAutoQ10',
        text: 'How important is the insurer’s reputation when choosing auto insurance?',
      },
      {
        questionId: 'insuranceAutoQ11',
        text: 'How important are available discounts (safe-driver, multi-policy) to you?',
      },
      {
        questionId: 'insuranceAutoQ12',
        text: 'How important is having a low deductible option?',
      },
    ],
    questionsLenderInfluence: [
      {
        questionId: 'insuranceAutoQ13',
        text: 'What factors influence your choice of auto insurance provider?',
      },
      {
        questionId: 'insuranceAutoQ14',
        text: 'When choosing auto insurance, which single factor matters most?',
      },
    ],
    questionsFlexible: [
      'Which payment frequency do you prefer? (monthly, quarterly, annual, usage-based)',
    ],
    feedback: [
      'What improvements would you suggest for the auto insurance process on web and mobile?',
    ],
  },
];

export const insuranceHome = [
  {
    questionsEasy: [
      'How easy was it to find home insurance options on the platform (both web and mobile web)?',
    ],
    questionsYesNo: [
      {
        questionId: 'insuranceHomeQ2',
        text: 'Did the platform clearly explain coverage types like dwelling, personal property, and liability?',
      },
      {
        questionId: 'insuranceHomeQ3',
        text: 'Were you able to view and compare deductible and premium options easily?',
      },
      {
        questionId: 'insuranceHomeQ4',
        text: 'Did you feel confident in understanding your estimated premium payments?',
      },
      {
        questionId: 'insuranceHomeQ5',
        text: 'Were there any optional coverages (e.g., flood, earthquake, umbrella) you expected but couldn’t find?',
      },
      {
        questionId: 'insuranceHomeQ6',
        text: 'Did the platform provide calculators or tools to help you estimate your insurance costs?',
      },
    ],
    questionsLikely: ['How likely are you to purchase home insurance through the platform?'],
    questionsSatisfied: ['How satisfied are you with the speed of getting a home insurance quote?'],
    questionsGoodPoor: ['How would you rate our customer support for home insurance inquiries?'],
    questionsImportant: [
      {
        questionId: 'insuranceHomeQ10',
        text: 'How important is the insurer’s reputation when choosing home insurance?',
      },
      {
        questionId: 'insuranceHomeQ11',
        text: 'How important are available discounts (multi-policy bundling, home safety upgrades) to you?',
      },
      {
        questionId: 'insuranceHomeQ12',
        text: 'How important is having a low deductible option?',
      },
    ],
    questionsLenderInfluence: [
      {
        questionId: 'insuranceHomeQ13',
        text: 'What factors influence your choice of home insurance provider?',
      },
      {
        questionId: 'insuranceHomeQ14',
        text: 'When choosing home insurance, which single factor matters most?',
      },
    ],
    questionsFlexible: ['Which payment option do you prefer? (monthly, semi-annual, annual)'],
    feedback: [
      'What improvements would you suggest for the home insurance process on web and mobile?',
    ],
  },
];
